import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Calendar, Plus } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });

const getStatusBadge = (date, t) => {
  const today = new Date().toISOString().split('T')[0];
  if (date === today) return <span className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">{t('dashboard.today')}</span>;
  if (date > today) return <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">{t('dashboard.upcoming')}</span>;
  return <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">{t('dashboard.past')}</span>;
};

const BookingsTab = ({ bookings, bookingsLoading, onNewBooking }) => {
  const { t } = useLanguage();

  return (
    <div data-testid="bookings-tab" className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
        <h2 className="font-semibold text-[#0d1442]">{t('dashboard.myBookings')}</h2>
        <button onClick={onNewBooking} className="flex items-center gap-2 px-4 py-2 text-sm bg-[#1a237e] text-white rounded-lg hover:bg-[#0d1442] transition-colors">
          <Plus className="w-4 h-4" />
          {t('dashboard.bookNow')}
        </button>
      </div>
      {bookingsLoading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin w-8 h-8 border-4 border-[#1a237e] border-t-transparent rounded-full" />
        </div>
      ) : bookings.length === 0 ? (
        <div data-testid="no-bookings" className="text-center py-12 text-slate-500">
          <Calendar className="w-12 h-12 mx-auto mb-4 text-slate-300" />
          <p>{t('dashboard.noBookings')}</p>
          <button onClick={onNewBooking} className="mt-4 px-6 py-2 bg-[#1a237e] text-white rounded-lg hover:bg-[#0d1442] transition-colors text-sm">
            {t('dashboard.bookNow')}
          </button>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase">{t('dashboard.date')}</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase">{t('dashboard.time')}</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase">{t('dashboard.company')}</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase">{t('dashboard.areaOfInterest')}</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase">{t('dashboard.status')}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {bookings.map(b => (
                <tr key={b.id} className="hover:bg-slate-50">
                  <td className="px-6 py-4 text-sm font-medium text-[#0d1442]">{formatDate(b.date)}</td>
                  <td className="px-6 py-4 text-sm text-slate-600">{b.time_slot}</td>
                  <td className="px-6 py-4 text-sm text-slate-600">{b.company_name}</td>
                  <td className="px-6 py-4 text-sm text-slate-600 max-w-xs truncate">{b.area_of_interest || '-'}</td>
                  <td className="px-6 py-4">{getStatusBadge(b.date, t)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BookingsTab;
